export const PendingIcon = ({ props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.00002 0.666748C3.05602 0.666748 0.666687 3.05608 0.666687 6.00008C0.666687 8.94408 3.05602 11.3334 6.00002 11.3334C8.94402 11.3334 11.3334 8.94408 11.3334 6.00008C11.3334 3.05608 8.94402 0.666748 6.00002 0.666748ZM6.00002 10.2667C3.64269 10.2667 1.73335 8.35741 1.73335 6.00008C1.73335 3.64275 3.64269 1.73341 6.00002 1.73341C8.35735 1.73341 10.2667 3.64275 10.2667 6.00008C10.2667 8.35741 8.35735 10.2667 6.00002 10.2667Z"
        fill="#737D86"
      />
    </svg>
  )
}
